import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationRU from './locales/ru/translation.json'; // Убедитесь, что путь корректный
import translationTJ from './locales/tj/translation.json'; // Убедитесь, что путь корректный

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: translationRU },
      tj: { translation: translationTJ },
      // Добавьте другие языки, если нужно
    },
    lng: 'ru', // Язык по умолчанию
    fallbackLng: 'ru',
    interpolation: {
      escapeValue: false, // React уже безопасен
    },
  });

export default i18n;
